// utils/rolePermissions/permissions.ts - object split (merged const; parts: rolesA, rolesB, rolesC)
import { rolesA } from './rolesA.js';
import { rolesB } from './rolesB.js';
import { rolesC } from './rolesC.js';

export const DEFAULT_ROLE_PERMISSIONS = {
  ...rolesA,
  ...rolesB,
  ...rolesC,
};
